import { SubmissionError } from 'redux-form'

const normalize = errorResponse => {
	let normalized = {}

	for (let error in errorResponse) {
		if (errorResponse.hasOwnProperty(error)) {
			normalized[error] = errorResponse[error]
		}
	}

	return normalized
}

export const handleErrors = (response) => {
	let errors = {}

	if (response.errors) {
		errors = normalize(response.errors)
	}

	if (response.errorsCommon) {
		errors['_error'] = response.errorsCommon
	}

	if (!(Object.keys(errors).length === 0)) throw new SubmissionError(errors)
  
	// We have to return the response, if there aren't any errors,
	// in order the promise chain to continue work
	return response
}

export default handleErrors
